export default "__VITE_ASSET__DGYLcHGr__"